import {CalendarDateValidator} from "@/components/ui/inputs/date/validator/CalendarDateValidator";

export class DefaultCalendarDateValidator extends CalendarDateValidator {
    public isValid(date: Date): boolean {
        return true;
    }
}
